import classNames from 'classnames';
import { useState } from 'react';
import dynamic from 'next/dynamic';
import Image from 'next/image';

import { MainLayout } from '@com/Layout';
import { useGetProfile } from '@api/user/user.rq';
import Icon from '@utilities/icon';

export enum OrderTypeTabEnum {
  'RX',
  'RXAttachment',
}

const RXRegistration = dynamic(() => import('@com/_organisms/RXRegistration'));

const PrescriptionContainer = () => {
  const { data } = useGetProfile();

  const [orderTypeTab, setOrderTypeTab] = useState<OrderTypeTabEnum>(
    OrderTypeTabEnum.RX,
  );

  const userInfo = data?.queryResult[0];

  return (
    <MainLayout
      title="داروی با نسخه"
      hasHeader
      headerType="withoutLogo"
      hasBackButton
    >
      <div className="w-full mb-5">
        <Image
          src={'/images/requestDrugsProgressBar.svg'}
          alt="progress-bar"
          width={328}
          height={66}
          objectFit="contain"
          className="m-auto"
        />
      </div>
      <div className="px-4 mb-4">
        <div
          className={
            'relative flex items-center w-full h-10  bg-surface-secondary p-1 gap-x-4 rounded-full'
          }
        >
          <div className="absolute w-[calc(100%-8px)] h-8">
            <div
              className={classNames(
                'absolute h-8 w-1/2 rounded-full bg-surface-primary transition-transform duration-200 left-0',
                orderTypeTab === OrderTypeTabEnum.RX
                  ? 'translate-x-full'
                  : 'translate-x-0',
              )}
            />
          </div>

          <div
            className="h-8 rounded-full w-full flex items-center justify-center bg-transparent z-10 cursor-pointer text-Label/Small"
            onClick={() => setOrderTypeTab(OrderTypeTabEnum.RX)}
          >
            نسخه با کدرهگیری
          </div>

          <div
            className="h-8 rounded-full w-full flex items-center justify-center bg-transparent z-10 cursor-pointer text-Label/Small"
            onClick={() => setOrderTypeTab(OrderTypeTabEnum.RXAttachment)}
          >
            نسخه با تصویر
          </div>
        </div>
      </div>

      <div className="flex items-start gap-3 rounded-md bg-surface-accentLight p-4 mx-4 my-3">
        <Icon
          name="CircleInformationFill"
          width={2}
          height={2}
          className="flex-shrink-0 mt-1 fill-surface-accent"
        />
        <p className="text-sm text-content-secondary">
          تنها داروخانه‌ها به محتوای نسخه الکترونیکی‌تان دسترسی دارند و این
          اطلاعات در اختیار تپسی‌دکتر قرار نمی‌گیرد.
        </p>
      </div>

      <RXRegistration userInfo={userInfo} orderTypeTab={orderTypeTab} />

      <div className="w-full mb-10 px-4 pb-[84px]">
        <Image
          src="/images/perscription-banner.svg"
          alt="progress-bar"
          layout="responsive"
          width={328}
          height={66}
          className="m-auto"
        />
      </div>
    </MainLayout>
  );
};
export default PrescriptionContainer;
